import Vue from 'vue'
import axios from 'axios'
import api from '@/api'

import {
    SET_DISCOUNT,
    SET_CONST_TOTAL_PRICE,
    SET_TOTAL_PRICE,
    SET_DELIVERY_PRICE,
    SET_SELECTED_PRODUCTS,
    SET_CURRENT_PRODUCT,
    SET_TOTAL_PRICE_NO_DISCOUNT,
    SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT,
    SET_PROFILE,
    SET_CASHBACK_SETTINGS,
    SET_LAZY_COMPONENT,
    SET_LOADING,
    SET_PROMOCODE,
    SET_UPSELL,
    SET_UPSELL_MESSAGE,
    SET_TWO_PLUS_ONE_MESSAGE,
    SET_UPSELL_ITEM_COUNT,
    SET_PROMOCODE_DATA,
    SET_SUM_PRODUCTS,
    SET_REPEAT_ORDER_ID,
    SET_BU_ID,
    SET_RUSSIAN_POST_INFO,
    SET_CDEK_INFO,
    SET_PEK_INFO,
    SET_SPECIAL_DELIVERY_METHOD,
    SET_DELIVERY_TO_CITY,
    SET_DELIVERY_METHOD_PVZ_ID,
    SET_DELIVERY_METHOD_PVZ_DATA,
    SET_SERVICE_FEE_PRICE,
    SET_DELIVERY_SERVICES
} from '@/store/mutations.type'

import {
    UPDATE_BASKET,
    SET_GLOBAL_ERROR,
    GET_BASKET,
    CLEAR_BASKET,
    ADD_TO_BASKET,
    ADD_UPSELL_TO_BASKET,
    CALC_RUSSIAN_POST,
    CALC_CDEK,
    CALC_TK_PEK,
    SET_EXPIRED_PRODUCTS
} from '@/store/actions.type'


const state = {
    discount: {
        description: '',
        name: '',
        type: 0,
        value: 0
    },
    constTotalPrice: 0, // only for updates from API, not from view components
    totalPrice: 0,
    sumProducts: 0,
    totalPriceNoDiscount: 0,
    totalOnlyProductsNoDiscount: 0,
    deliveryPrice: 0,
    promocode: null,
    promocodeData: null,
    selectedProducts: [],
    currentProduct: null,
    upsell: [],
    upsellMessage: [],
    twoPlusOneMessage: [],
    repeatOrderId: null,
    buId: null,
    cdekInfo: [],
    russianPostInfo: [],
    pekInfo: {},
    specialDeliveryMethod: {},
    deliveryToCity: '',
    deliveryMethodPvzId: '',
    deliveryMethodPvzData: '',
    expiredProducts: [],
    totalServiceFeePrice: 0,
}

const getters = {
    deliveryMethodPvzId(state) {
        return state.deliveryMethodPvzId
    },
    deliveryMethodPvzData(state) {
        return state.deliveryMethodPvzData
    },
    deliveryToCity(state) {
        return state.deliveryToCity
    },
    specialDeliveryMethod(state) {
        return state.specialDeliveryMethod
    },
    pekInfo(state) {
        return state.pekInfo
    },
    cdekInfo(state) {
        return state.cdekInfo
    },
    russianPostInfo(state) {
        return state.russianPostInfo
    },
    discount(state) {
        return state.discount
    },
    constTotalPrice(state) {
        return state.constTotalPrice
    },
    totalPrice(state, getters, rootState, rootGetters) {

        // if (state.specialDeliveryMethod && state.specialDeliveryMethod.value && Math.round(rootGetters.outletSettings.free_shipping_from - rootGetters.totalOnlyProductsNoDiscount) > 0) {
        //     return state.totalPrice + Number(state.specialDeliveryMethod.value)
        // }
        if (state.specialDeliveryMethod && state.specialDeliveryMethod.value) {
            return state.totalPrice + Number(state.specialDeliveryMethod.value)
        }
        if (state.specialDeliveryMethod && state.specialDeliveryMethod.total) {
            return state.totalPrice + Number(state.specialDeliveryMethod.total)
        }
        if (state.specialDeliveryMethod && state.specialDeliveryMethod.price) {
            return state.totalPrice + Number(state.specialDeliveryMethod.price)
        }
        return state.totalPrice
    },
    sumProducts(state) {
        return state.sumProducts
    },
    totalPriceNoDiscount(state) {
        return state.totalPriceNoDiscount
    },
    totalOnlyProductsNoDiscount(state) {
        return state.totalOnlyProductsNoDiscount
    },
    deliveryPrice(state) {
        return state.deliveryPrice
    },
    selectedProducts(state) {
        return state.selectedProducts
    },
    currentProduct(state) {
        return state.currentProduct
    },
    promocode(state) {
        return state.promocode
    },
    promocodeData(state) {
        return state.promocodeData
    },
    upsell(state) {
        return state.upsell
    },
    upsellMessage(state) {
        return state.upsellMessage
    },
    twoPlusOneMessage(state) {
        return state.twoPlusOneMessage
    },
    expiredProducts(state) {
        return state.expiredProducts
    },
    serviceFeePrice(state) {
        return state.totalServiceFeePrice
    }
}


export const mutations = {
    [SET_DELIVERY_METHOD_PVZ_ID](state, data) {
        state.deliveryMethodPvzId = data
    },
    [SET_DELIVERY_METHOD_PVZ_DATA](state, data) {
        state.deliveryMethodPvzData = data
    },
    [SET_DELIVERY_TO_CITY](state, data) {
        state.deliveryToCity = data
    },
    [SET_SPECIAL_DELIVERY_METHOD](state, data) {
        state.specialDeliveryMethod = data
    },
    [SET_PEK_INFO](state, data) {
        state.pekInfo = data
    },
    [SET_RUSSIAN_POST_INFO](state, data) {
        state.russianPostInfo = data
    },
    [SET_CDEK_INFO](state, data) {
        state.cdekInfo = data
    },
    [SET_BU_ID](state, data) {
        state.buId = data
    },
    [SET_REPEAT_ORDER_ID](state, data) {
        state.repeatOrderId = data
    },
    [SET_DISCOUNT](state, data) {
        state.discount = data
    },
    [SET_CONST_TOTAL_PRICE](state, data) {
        state.constTotalPrice = data
    },
    [SET_TOTAL_PRICE](state, data) {
        state.totalPrice = data
    },
    [SET_SUM_PRODUCTS](state, data) {
        state.sumProducts = data
    },
    [SET_TOTAL_PRICE_NO_DISCOUNT](state, data) {
        state.totalPriceNoDiscount = data
    },
    [SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT](state, data) {
        state.totalOnlyProductsNoDiscount = data
    },
    [SET_DELIVERY_PRICE](state, data) {
        state.deliveryPrice = data
    },
    [SET_SELECTED_PRODUCTS](state, data) {
        state.selectedProducts = data
    },
    [SET_CURRENT_PRODUCT](state, data) {
        state.currentProduct = data
    },
    [SET_PROMOCODE](state, data) {
        state.promocode = data
    },
    [SET_PROMOCODE_DATA](state, data) {
        state.promocodeData = data
    },
    [SET_UPSELL](state, data) {
        for (let i in data) {
            data[i].count = 1
        }
        state.upsell = data
    },
    [SET_UPSELL_MESSAGE](state, data) {
        state.upsellMessage = data
    },
    [SET_TWO_PLUS_ONE_MESSAGE](state, data) {
        state.twoPlusOneMessage = data
    },
    [SET_UPSELL_ITEM_COUNT](state, { id, data }) {
        for (let i in state.upsell) {
            if (state.upsell[i].id === id) {
                state.upsell[i].count = data
                break
            }
        }
    },
    [SET_EXPIRED_PRODUCTS](state, data) {
        state.expiredProducts = data
    },
    [SET_SERVICE_FEE_PRICE](state, data) {
        state.totalServiceFeePrice = data
    },
}

export const actions = {
    async [CALC_TK_PEK](context, { delivery_method_id }) {
        return axios({
            method: 'POST',
            url: api.specialPost.calcPEK.url(),
            data: {
                delivery_method_id: delivery_method_id,
                city_name: context.state.deliveryToCity,
                products: context.state.selectedProducts.map(product => ({ id: product.id, qty: product.count })),
                total: context.state.totalOnlyProductsNoDiscount
            }
        }).then(response => {
            context.commit(SET_PEK_INFO, response.data)
            return response.data
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },
    async [CALC_CDEK](context, { delivery_method_id, post_code }) {
        return axios({
            method: 'POST',
            url: api.specialPost.calcCDEK.url(),
            data: {
                delivery_method_id: delivery_method_id,
                delivery_address_post_code: post_code,
                products: context.state.selectedProducts.map(product => ({ id: product.id, qty: product.count })),
                total: context.state.totalOnlyProductsNoDiscount
            }
        }).then(response => {
            context.commit(SET_CDEK_INFO, response.data)
            return response.data
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },
    async [CALC_RUSSIAN_POST](context, { delivery_method_id, post_code }) {
        return axios({
            method: 'POST',
            url: api.specialPost.calcRussPost.url(),
            data: {
                delivery_method_id: delivery_method_id,
                delivery_address_post_code: post_code,
                products: context.state.selectedProducts.map(product => ({ id: product.id, qty: product.count })),
                total: context.state.totalOnlyProductsNoDiscount
            }
        }).then(response => {
            context.commit(SET_RUSSIAN_POST_INFO, response.data)
            return response.data
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    async [UPDATE_BASKET](context, { basketItemId, productId, count, modifiers, resourceId, pickedPeriod, modifiers_new }) {
        if (context.getters.loading[UPDATE_BASKET] === true) {
            return
        }

        context.commit(SET_LOADING, { process: UPDATE_BASKET, loading: true })

        return await axios({
            method: 'POST',
            url: api.basket.updateBasket.url(),
            data: {
                basket_item_id: basketItemId,
                dish_id: productId,
                count,
                modifiers,
                modifiers_new,
                resourceId,
                pickedPeriod,
                promocode: context.getters.promocode
            }
        }).then(response => {
            context.commit(SET_DELIVERY_SERVICES, response.data.delivery_methods)
            context.commit(SET_PROFILE, response.data.profile)
            context.commit(SET_CONST_TOTAL_PRICE, response.data.total)
            context.commit(SET_TOTAL_PRICE, response.data.total)
            context.commit(SET_SUM_PRODUCTS, response.data.products_sum)
            context.commit(SET_TOTAL_PRICE_NO_DISCOUNT, response.data.totalNoDiscount)
            context.commit(SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT, response.data.totalOnlyProductsNoDiscount)
            context.commit(SET_DELIVERY_PRICE, response.data.delivery)
            context.commit(SET_SELECTED_PRODUCTS, response.data.data)
            context.commit(SET_DISCOUNT, response.data.discount)
            context.commit(SET_PROMOCODE_DATA, response.data.promocode)
            context.commit(SET_UPSELL, response.data.upsell)
            context.commit(SET_UPSELL_MESSAGE, response.data.upsellMessage)
            context.commit(SET_TWO_PLUS_ONE_MESSAGE, response.data.twoPlusOneMessage)
            context.commit(SET_CASHBACK_SETTINGS, response.data.cashback)
            context.commit(SET_LAZY_COMPONENT, { component: 'basket', 'state': true })
            context.commit(SET_SERVICE_FEE_PRICE, response.data.totalServiceFeePrice)



            // Удаление просроченных товаров
            if (context.state.expiredProducts.length > 0) {
                let expired = [];
                response.data.data.forEach(item => {
                    context.state.expiredProducts.forEach(expiredId => {
                        if (expiredId === item.id) {
                            expired.push(expiredId);
                        }
                    })
                })
                context.commit(SET_EXPIRED_PRODUCTS, expired);
            }


        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: UPDATE_BASKET, loading: false })
        })
    },

    async [ADD_TO_BASKET](context, { productId, count, modifiers, resourceId, pickedPeriod, modifiers_new }) {
        if (context.getters.loading[ADD_TO_BASKET] === true) {
            return
        }

        context.commit(SET_LOADING, { process: ADD_TO_BASKET, loading: true })

        return await axios({
            method: 'PUT',
            url: api.basket.addToBasket.url(),
            data: {
                dish_id: productId,
                count,
                modifiers,
                modifiers_new,
                resourceId,
                pickedPeriod,
                promocode: context.getters.promocode
            }
        }).then(response => {
            context.commit(SET_DELIVERY_SERVICES, response.data.delivery_methods)
            context.commit(SET_PROFILE, response.data.profile)
            context.commit(SET_CONST_TOTAL_PRICE, response.data.total)
            context.commit(SET_TOTAL_PRICE, response.data.total)
            context.commit(SET_SUM_PRODUCTS, response.data.products_sum)
            context.commit(SET_TOTAL_PRICE_NO_DISCOUNT, response.data.totalNoDiscount)
            context.commit(SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT, response.data.totalOnlyProductsNoDiscount)
            context.commit(SET_DELIVERY_PRICE, response.data.delivery)
            context.commit(SET_SELECTED_PRODUCTS, response.data.data)
            context.commit(SET_DISCOUNT, response.data.discount)
            context.commit(SET_PROMOCODE_DATA, response.data.promocode)
            context.commit(SET_UPSELL, response.data.upsell)
            context.commit(SET_UPSELL_MESSAGE, response.data.upsellMessage)
            context.commit(SET_TWO_PLUS_ONE_MESSAGE, response.data.twoPlusOneMessage)
            context.commit(SET_CASHBACK_SETTINGS, response.data.cashback)
            context.commit(SET_LAZY_COMPONENT, { component: 'basket', 'state': true })
            context.commit(SET_SERVICE_FEE_PRICE, response.data.totalServiceFeePrice)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: ADD_TO_BASKET, loading: false })
        })
    },

    async [ADD_UPSELL_TO_BASKET](context) {
        if (context.getters.loading[ADD_UPSELL_TO_BASKET] === true) {
            return
        }

        context.commit(SET_LOADING, { process: ADD_UPSELL_TO_BASKET, loading: true })

        return await axios({
            method: 'PUT',
            url: api.basket.addUpsellToBasket.url(),
            data: {
                upsell: context.getters.upsell,
                promocode: context.getters.promocode
            }
        }).then(response => {
            context.commit(SET_DELIVERY_SERVICES, response.data.delivery_methods)
            context.commit(SET_PROFILE, response.data.profile)
            context.commit(SET_CONST_TOTAL_PRICE, response.data.total)
            context.commit(SET_TOTAL_PRICE, response.data.total)
            context.commit(SET_SUM_PRODUCTS, response.data.products_sum)
            context.commit(SET_TOTAL_PRICE_NO_DISCOUNT, response.data.totalNoDiscount)
            context.commit(SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT, response.data.totalOnlyProductsNoDiscount)
            context.commit(SET_DELIVERY_PRICE, response.data.delivery)
            context.commit(SET_SELECTED_PRODUCTS, response.data.data)
            context.commit(SET_DISCOUNT, response.data.discount)
            context.commit(SET_PROMOCODE_DATA, response.data.promocode)
            context.commit(SET_UPSELL, response.data.upsell)
            context.commit(SET_UPSELL_MESSAGE, response.data.upsellMessage)
            context.commit(SET_TWO_PLUS_ONE_MESSAGE, response.data.twoPlusOneMessage)
            context.commit(SET_CASHBACK_SETTINGS, response.data.cashback)
            context.commit(SET_LAZY_COMPONENT, { component: 'basket', 'state': true })
            context.commit(SET_SERVICE_FEE_PRICE, response.data.totalServiceFeePrice)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        }).finally(() => {
            context.commit(SET_LOADING, { process: ADD_UPSELL_TO_BASKET, loading: false })
        })
    },

    async [GET_BASKET](context) {
        return axios({
            method: 'POST',
            url: api.basket.getBasket.url(),
            data: {
                promocode: context.getters.promocode,
                repeat_order_id: context.state.repeatOrderId,
                bu: context.state.buId
            }
        }).then(response => {
            context.commit(SET_DELIVERY_SERVICES, response.data.delivery_methods)
            context.commit(SET_PROFILE, response.data.profile)
            context.commit(SET_CONST_TOTAL_PRICE, response.data.total)
            context.commit(SET_TOTAL_PRICE, response.data.total)
            context.commit(SET_SUM_PRODUCTS, response.data.products_sum)
            context.commit(SET_TOTAL_PRICE_NO_DISCOUNT, response.data.totalNoDiscount)
            context.commit(SET_TOTAL_PRICE_ONLY_PRODUCTS_NO_DISCOUNT, response.data.totalOnlyProductsNoDiscount)
            context.commit(SET_DELIVERY_PRICE, response.data.delivery)
            context.commit(SET_SELECTED_PRODUCTS, response.data.data)
            context.commit(SET_DISCOUNT, response.data.discount)
            context.commit(SET_PROMOCODE_DATA, response.data.promocode)
            context.commit(SET_UPSELL, response.data.upsell)
            context.commit(SET_UPSELL_MESSAGE, response.data.upsellMessage)
            context.commit(SET_TWO_PLUS_ONE_MESSAGE, response.data.twoPlusOneMessage)
            context.commit(SET_CASHBACK_SETTINGS, response.data.cashback)
            context.commit(SET_LAZY_COMPONENT, { component: 'basket', 'state': true })
            context.commit(SET_SERVICE_FEE_PRICE, response.data.totalServiceFeePrice)
            return response.data
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    },

    async [CLEAR_BASKET](context) {
        axios({
            method: 'DELETE',
            url: api.basket.clearBasket.url()
        }).then(() => {
            context.commit(SET_CONST_TOTAL_PRICE, 0)
            context.commit(SET_SELECTED_PRODUCTS, [])
            context.commit(SET_UPSELL, [])
            context.commit(SET_UPSELL_MESSAGE, [])
            context.commit(SET_TWO_PLUS_ONE_MESSAGE, [])
            context.commit(SET_TOTAL_PRICE, 0)
            context.commit(SET_SUM_PRODUCTS, 0)
            context.commit(SET_SERVICE_FEE_PRICE, 0)
        }).catch(error => {
            context.dispatch(SET_GLOBAL_ERROR, { error: error, defaultError: new Vue().text('error') })
        })
    }


}

export default {
    state,
    mutations,
    getters,
    actions
}